<template>
  <div class="container padding-y-md">
    <div
      class="bandana-new-pack-notice position-relative"
      style="background-color: var(--yellow4); border-radius: var(--border-radius-lg)"
    >
      <div style="position: relative; z-index: 1">
        <div class="display-flex flex-items-center flex-wrap padding-y-md padding-x-md">
          <div class="display-flex flex-items-center flex-wrap">
            <font-awesome-icon
              :icon="$v7.solid.faOpossum"
              size="2x"
            />
            <p class="margin-0 padding-x-md">
              <strong>{{ headlineText }}</strong> •
              <site-link
                :to="{ name: 'changelog' }"
                class="primary"
                style="--link-color: var(--fa-navy); --link-hover-color: var(--yellow9)"
              >
                See what's new &rarr;
              </site-link>
            </p>
          </div>
          <div class="display-flex align-middle margin-auto laptop:margin-left-auto laptop:margin-right-0 padding-top-xs laptop:padding-0">
            <site-link
              v-if="isActiveProPlus"
              :to="$pack({ name: 'graphite' })"
              class="button flat with-border margin-0"
              :style="ctaButtonStyle"
            >
              Explore Graphite
            </site-link>

            <site-link
              v-else-if="!isActivePro"
              :to="{ name: 'plans.pro', query: { discount: 'GRAPHITE20' } }"
              class="button flat with-border margin-0"
              :style="ctaButtonStyle"
              @click.native="
                purchaseFlowEvent('get_pro_button_click', {
                  context: 'new_release_bandana',
                  required_pro_level: 'pro',
                  featured: 'graphite'
                })
              "
            >
              <span
                class="tag rounded primary margin-right-sm"
                style="background: var(--fa-navy)"
                >On sale</span
              >
              Save on Pro!
            </site-link>

            <site-link
              v-else
              :to="{ name: 'plans.pro-plus', query: { discount: 'GRAPHITE20UP' } }"
              class="button flat with-border margin-0"
              :style="ctaButtonStyle"
              @click.native="
                purchaseFlowEvent('get_pro_button_click', {
                  context: 'new_release_bandana',
                  required_pro_level: 'plus',
                  featured: 'graphite'
                })
              "
            >
              <span
                class="tag rounded primary margin-right-sm"
                style="background: var(--fa-navy)"
                >On sale</span
              >
              Save on Pro+!
            </site-link>
          </div>
        </div>
      </div>
      <div
        aria-hidden="true"
        style="
          position: absolute;
          inset: 0;
          background-color: var(--yellow5);
          -webkit-mask-image: url('/images/tile-7-2.svg');
          -webkit-mask-repeat: repeat;
          -webkit-mask-size: 766px;
          -webkit-mask-position: center;
          mask-image: url('/images/tile-7-2.svg');
          mask-repeat: repeat;
          mask-size: 766px;
          mask-position: center;
          pointer-events: none;
        "
      ></div>
    </div>
  </div>
</template>
<script>
  import { EventTrackingMixin } from 'app/mixins'

  export default {
    name: 'NewPackNotice',

    mixins: [EventTrackingMixin],

    computed: {
      isActivePro() {
        return Boolean(this.$dt?.isPro && this.$dt?.active)
      },
      isActiveProPlus() {
        return Boolean(this.$permits?.has?.('accessToProPlus') && this.$dt?.active)
      },
      headlineText() {
        if (this.isActiveProPlus) {
          return 'The new Graphite Pro+ icon pack has landed in 7.2.0'
        }
        return 'Font Awesome 7.2 is here with new icons and a new Pro+ pack'
      },
      ctaButtonStyle() {
        return {
          '--button-color': 'var(--fa-navy)',
          '--border-color': 'var(--yellow6)',
          '--button-background': 'var(--yellow4)',
          '--button-hover-color': 'var(--fa-navy)',
          '--button-hover-background': 'var(--yellow6)',
          '--button-hover-border-color': 'var(--yellow6)'
        }
      }
    }
  }
</script>
